import axios from "axios";
import React, { useState } from "react";
import { X } from "lucide-react";
import { showError, showSuccess } from "../../../utils/toastUtils";
import UserSlotPicker from "../../UserSideComponents/bookings/UserSlotPicker";

// bookingType: "service" | "package"
const RescheduleBookingModal = ({
  booking,
  onClose,
  onSuccess,
  branchId,
  bookingType = "service",
}) => {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!booking) return null;

  const handleSave = async () => {
    if (!selectedSlot) {
      return showError("Please select a new date & time slot");
    }

    try {
      setIsSubmitting(true);

      const payload = {
        status: "rescheduled",
        branchId,
        rescheduledDate: selectedSlot.date,
        slotAvailabilityId: selectedSlot.availabilityId,
        slotId: selectedSlot.slotId,
        slotSnapshot: {
          startTime: selectedSlot.startTime,
          endTime: selectedSlot.endTime,
          slotName: selectedSlot.slotName || null,
        },
      };

      // ── Pick endpoint based on bookingType ──
      const endpoint =
        bookingType === "package"
          ? `${process.env.REACT_APP_API_URL}/package-bookings/${booking._id}`
          : `${process.env.REACT_APP_API_URL}/service-bookings/update/${booking._id}`;

      const res = await axios.put(endpoint, payload);

      showSuccess("Booking rescheduled successfully");
      onSuccess?.(res?.data?.data);
      onClose();
    } catch (err) {
      console.error("Reschedule failed", err);
      showError(err?.response?.data?.message || "Failed to reschedule booking");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white animate-slideUp duration-300 rounded-xl overflow-hidden shadow-xl w-full max-w-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex justify-between bg-accentTextColor/80 items-center p-5 border-b">
          <h3 className="text-lg font-bold capitalize">Reschedule {bookingType} Booking</h3>
          <button onClick={onClose}>
            <X />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 space-y-4 min-h-[22rem]">
          <UserSlotPicker
            value={selectedSlot}
            onChange={(slot) => setSelectedSlot(slot)}
            branchId={branchId}
          />
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-5 border-t bg-gray-50">
          <button onClick={onClose} className="flex-1 border rounded-lg py-3">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isSubmitting}
            className="flex-1 bg-primaryColor text-white rounded-lg py-3"
          >
            {isSubmitting ? "Rescheduling…" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RescheduleBookingModal;












// import axios from "axios";
// import React, { useState } from "react";
// import { X } from "lucide-react";
// import { showError, showSuccess } from "../../../utils/toastUtils";
// import UserSlotPicker from "../../UserSideComponents/bookings/UserSlotPicker";

// const RescheduleBookingModal = ({ booking, onClose, onSuccess, branchId }) => {
//   // console.log("booking:", booking);
//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   if (!booking) return null;

//   const handleSave = async () => {
//     if (!selectedSlot) {
//       return showError("Please select a new date & time slot");
//     }

//     try {
//       setIsSubmitting(true);

//       const payload = {
//         status: "rescheduled",
//         branchId,
//         rescheduledDate: selectedSlot.date,
//         slotAvailabilityId: selectedSlot.availabilityId,
//         slotId: selectedSlot.slotId,
//         slotSnapshot: {
//           startTime: selectedSlot.startTime,
//           endTime: selectedSlot.endTime,
//           slotName: selectedSlot.slotName || null,
//         },
//       };

//       const res = await axios.put(
//         `${process.env.REACT_APP_API_URL}/service-bookings/update/${booking._id}`,
//         payload,
//       );
//       // console.log("booking res:", res);

//       showSuccess("Booking rescheduled successfully");
//       onSuccess?.(res?.data?.data);
//       onClose();
//     } catch (err) {
//       console.error("Reschedule failed", err);
//       showError("Failed to reschedule booking");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div
//       className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white animate-slideUp duration-300 rounded-xl overflow-hidden shadow-xl w-full max-w-xl"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Header */}
//         <div className="flex justify-between  bg-accentTextColor/80 items-center p-5 border-b">
//           <h3 className="text-lg font-bold">Reschedule Booking</h3>
//           <button onClick={onClose}>
//             <X />
//           </button>
//         </div>

//         {/* Body */}
//         <div className="p-5 space-y-4 min-h-[22rem]">
//           <UserSlotPicker
//             value={selectedSlot}
//             onChange={(slot) => setSelectedSlot(slot)}
//             branchId={branchId}
//           />
//         </div>

//         {/* Footer */}
//         <div className="flex gap-3 p-5 border-t bg-gray-50">
//           <button onClick={onClose} className="flex-1 border rounded-lg py-3">
//             Cancel
//           </button>
//           <button
//             onClick={handleSave}
//             disabled={isSubmitting}
//             className="flex-1 bg-primaryColor text-white rounded-lg py-3"
//           >
//             {isSubmitting ? "Rescheduling…" : "Confirm "}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RescheduleBookingModal;
